module.exports = __webpack_public_path__ + "img/yaoqingbg.2af2f6dd.png";